/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.27",
    versionName: "0.2.0-nightly.2025.11.27",
    versionChannel: "nightly",
    buildDate: "2025-11-27T00:09:03.686Z",
    commitHash: "b0ccf48513d4fc9e3c2ee7602a03e2e02d2dbf2b",
};
